// Utility functions for creating returns

export const createReturnFromOrder = (navigate, order, platform = null) => {
  const orderPlatform = platform || order.platform;
  const orderId = order.orderId || order.id || order.order_id;

  if (!orderId || !orderPlatform) {
    console.error('Missing required order data for return creation');
    return;
  }

  // Navigate to create return with URL parameters
  navigate(`/returns/new?orderId=${orderId}&platform=${orderPlatform}`);
};

export const createReturnFromOrderWithState = (navigate, orderData) => {
  // Navigate to create return with order data in state
  navigate('/returns/new', {
    state: { order: orderData }
  });
};

export const getReturnButtonProps = (order, platform = null) => {
  return {
    variant: 'contained',
    size: 'small',
    color: 'primary',
    sx: { 
      minWidth: 'auto',
      textTransform: 'none'
    }
  };
};

export const formatOrderForReturn = (order, platform) => {
  return {
    ...order,
    platform: platform,
    orderId: order.orderId || order.id || order.order_id,
    customerName: order.customerName || order.buyerName || order.customer_name,
    customerEmail: order.customerEmail || order.buyerEmail || order.customer_email
  };
};